import React, { useEffect, useContext, useState } from "react";
import { isMobile } from "react-device-detect";
import KeyboardEventHandler from "@infinium/react-keyboard-event-handler";
import { useQuery } from "@apollo/client";
import { useParams, useHistory } from "react-router-dom";

import ReadersRow from "./row";
import { DataContext } from "../../../context/data-context";
import { LangItem } from "../../../models/lang";
import { CatItem, ReaderItem } from "../../../models/reader";
import FirstModal from "./student_modal";
import { UserItem } from "../../../models/user";
import { LIBRARYFETCH, GETASSIGNMENT } from "./queries";
import Assigment from "./assignment";
import StarterSteps from "./starter_steps";
import RenderComingSoon from "./coming_soon";
import { GET_READERS } from "../../../middleware/queries";
import BookInfo from "./bookInfo";
import BookAuthorInfo from "../authors/bookInfo";
import { Helmet } from "react-helmet";
import LanguageSelect from "../../common/langSelection";
import MarketingModal from "./marketing_modal";
import { Popup } from "../../../models/popups";
import {
  getAuthCookie,
  setAuthCookie,
} from "../../../middleware/cookie-manager";
import { IconJumbotron } from "../../common/icons";

const Library: React.FC = () => {
  const history = useHistory();
  const user_local = getAuthCookie(true);
  const [user, setUser] = useState<UserItem>(user_local);
  const [x_arr, setXarr] = useState<number[]>([]);
  const [keyNav, setKeyNav] = useState<
    | {
        y: number;
        x: number;
        view: boolean;
        keyboard: boolean;
      }
    | false
  >(false);
  const [activeReader, setActiveReader] = useState<ReaderItem | false>(false);
  const [activeCat, setActiveCat] = useState<{
    id: string | false;
    books_num: number;
  }>({ id: false, books_num: 0 });
  const { lang_name } = useParams<{ lang_name: string }>();
  const dataContext = useContext(DataContext);
  const {
    data: library_fetch = {
      getContinueReading: dataContext.first_data?.continueReading || undefined,
      getRecentReading: dataContext.first_data?.recentReading || undefined,
      getpopups: dataContext.first_data?.popups || undefined,
    },
  } = useQuery<{
    getContinueReading: ReaderItem[];
    getRecentReading: ReaderItem[];
    getpopups: Popup[];
  }>(LIBRARYFETCH, {
    fetchPolicy: "cache-and-network",
    skip: dataContext.first_load,
    variables: {
      lang_id: user.lang_id,
    },
  });
  const { data: get_assignment } = useQuery(GETASSIGNMENT, {
    fetchPolicy: "cache-and-network",
    skip: user.is_teacher,
    variables: { class_id: user.class_id, lang_id: user.lang_id },
  });
  const { data: get_readers } = useQuery(GET_READERS, {
    fetchPolicy: "no-cache",
    skip: user.is_teacher,
    variables: {
      class_id: user.class_id,
      lang_id: user.lang_id,
      reader_type: user.is_teacher ? "flangoo" : "all",
    },
  });
  const [readers, setReader] = useState<ReaderItem[]>(
    JSON.parse(localStorage.getItem("local_readers") || "[]"),
  );
  const categories: CatItem[] = localStorage.getItem("local_readers")
    ? JSON.parse(localStorage.getItem("local_categories") || "{}")
    : [];
  const languages = JSON.parse(localStorage.getItem("local_languages") || "{}");

  useEffect(() => {
    const clean_cats = cleanCategories(categories);
    localStorage.setItem("local_categories", JSON.stringify(clean_cats));

    setXarr(categories.map(() => 0));
    const selected_lang: LangItem = languages.find(
      (lang: LangItem) => lang.id === user.lang_id,
    );
    if (selected_lang) {
      setAuthCookie({ ...user, lang_name: selected_lang.name } as UserItem);
      setUser({ ...user, lang_name: selected_lang.name } as UserItem);
    }
    const storage_key_nav = JSON.parse(localStorage.getItem("keyNav") || "{}");
    if (storage_key_nav.x !== undefined) {
      localStorage.removeItem("keyNav");
      setKeyNav({ ...storage_key_nav, view: false });
    }
    return () => {
      const body = document.body;
      body.classList.remove("scroll_lock");
      setActiveCat({ id: false, books_num: activeCat.books_num });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!activeReader) {
      const body = document.body;
      body.classList.remove("scroll_lock");
      setActiveCat({ id: false, books_num: activeCat.books_num });
    } else {
      if (isMobile) {
        ///save active reader to local storage
        localStorage.setItem("keyNav", JSON.stringify(keyNav));
        history.push(`/bookdetails/${activeReader.url}/${activeReader.id}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeReader]);

  useEffect(() => {
    if (get_readers && get_readers.books) {
      const order_readers = get_readers.books.sort(
        (a: ReaderItem, b: ReaderItem) => {
          // Sort by coming_soon
          if (a.coming_soon && !b.coming_soon) {
            return -1;
          } else if (!a.coming_soon && b.coming_soon) {
            return 1;
          }
          // Sort by is_new (if exists)
          if (a.is_new && !b.is_new) {
            return -1;
          } else if (!a.is_new && b.is_new) {
            return 1;
          }
          // Sort by rank
          return a.rank > b.rank ? 1 : -1;
        },
      );
      localStorage.setItem("local_readers", JSON.stringify(order_readers));
      setReader(order_readers);
    }
    return () => {
      dataContext.setfirstLoad(false);
      dataContext.setfirstDataLoad(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get_readers]);

  useEffect(() => {
    if (lang_name) {
      const selected_lang: LangItem = languages.find(
        (lang: LangItem) => lang.name.toLocaleLowerCase() === lang_name,
      );
      if (selected_lang) {
        dataContext.setLang(selected_lang.id);
        dataContext.setLoaded(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang_name]);

  useEffect(() => {
    if (keyNav) {
      console.log("keyNav", keyNav);
      if (keyNav.keyboard || keyNav.view) {
        scrollRow();
        slectActiveReaderKeyboard();
      } else {
        scrollRow();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyNav]);

  const cleanCategories = (categories: CatItem[]) => {
    const clean_cats: CatItem[] = [];
    ///search if there's at least one book with the category id
    categories.forEach((cat) => {
      const cat_readers = readers.filter((reader) => {
        let has_book = false;
        let is_weekly = false;
        reader.categories.find((c) => {
          if (c.id === "23" && cat.id === "4") {
            has_book = false;
            is_weekly = true;
          }
          has_book = has_book || c.id === cat.id;
          return has_book;
        });
        if (!is_weekly && cat.is_level && reader.level_id === cat.id)
          has_book = true;

        return has_book;
      });
      if (cat_readers.length > 0) {
        clean_cats.push(cat);
      }
    });
    return clean_cats;
  };
  const discardFunction = () => {
    const set_user = { ...user };
    set_user.show_steps = false;
    setAuthCookie(set_user as UserItem);
    setUser(set_user as UserItem);
  };

  const slectActiveReader = (ev: { currentTarget: HTMLElement }) => {
    const y_val = ev.currentTarget.dataset.rownum;
    const x_val = ev.currentTarget.dataset.xval;
    const set_key_nav = keyNav
      ? { ...keyNav }
      : { y: 0, x: 0, view: true, keyboard: false };
    if (y_val && x_val) {
      set_key_nav.y = parseInt(y_val);
      set_key_nav.x = parseInt(x_val);
    }
    set_key_nav.view = true;
    setKeyNav(set_key_nav);
  };

  const arrowNav = (
    y_val: number,
    x_val: number,
    direction: "left" | "right",
  ) => {
    const set_key_nav = keyNav
      ? { ...keyNav }
      : { y: 0, x: 0, view: false, keyboard: false };
    const steps = set_key_nav.view || activeCat.id === "is_trending" ? 1 : 1;
    set_key_nav.keyboard = false;
    set_key_nav.x = direction === "left" ? x_val - steps : x_val + steps;
    if (set_key_nav.x < 0) {
      set_key_nav.x = 0;
    }
    set_key_nav.y = y_val;
    setKeyNav(set_key_nav);
  };

  const slectActiveReaderKeyboard = () => {
    if (!keyNav) return;
    let { x: book_num, y: rowNum, view } = keyNav;
    if (!view) {
      console.log("view is false, returning");
      return;
    }
    let cat: CatItem =
      rowNum === -1
        ? {
            is_level: false,
            id: "continue_reading",
            name: "Continue Reading",
            buy_text: "",
            books_num: 0,
            is_trending: false,
          }
        : rowNum >= categories.length
          ? {
              is_level: false,
              id: "recent_reading",
              name: "Recent Reading",
              buy_text: "",
              books_num: 0,
              is_trending: false,
            }
          : categories[rowNum];

    let level_readers = [];
    if (cat.id === "continue_reading" && library_fetch?.getContinueReading) {
      level_readers = library_fetch.getContinueReading;
    } else if (cat.id === "recent_reading" && library_fetch?.getRecentReading) {
      level_readers = library_fetch.getRecentReading;
    } else {
      level_readers = getCatReaders(cat);
    }
    if (level_readers.length < 1) {
      console.log("No readers found for this category, returning");
      return null;
    }

    if (book_num > level_readers.length - 1) {
      ///means we are at in an infinite row position
      const lap = Math.floor(book_num / level_readers.length);
      book_num = book_num - level_readers.length * lap;
    }
    const selected_reader = level_readers[book_num];
    console.log("Selected reader:", selected_reader, "for category:", cat);
    if (selected_reader) {
      setActiveReader(selected_reader);
      console.log("Active cat:", cat);
      if (cat.id) {
        setActiveCat({ id: cat.id, books_num: level_readers.length });
        scrollCat(cat.id);
      }
    }
  };

  const scrollCat = (cat_id: string, tries = 0) => {
    const body = document.body;
    const cat = document.getElementById(cat_id) as HTMLHeadingElement;
    const book_info = document.getElementById("book_info") as HTMLDivElement;

    if (!cat || !book_info) {
      ///avoid infinite loop
      if (tries < 5) {
        setTimeout(() => {
          scrollCat(cat_id, tries + 1);
        }, 100);
      }
      return;
    }
    const catPosition = cat.getBoundingClientRect().top;
    const offsetPosition =
      catPosition + window.pageYOffset - book_info.offsetHeight - 1;
    body.classList.add("scroll_lock");
    window.scrollTo({
      top: offsetPosition,
    });
  };

  const handleKeyboardNav = (key_value: string) => {
    const min_y =
      library_fetch &&
      library_fetch.getContinueReading &&
      library_fetch.getContinueReading.length > 0
        ? -1
        : 0;
    const set_key_nav = keyNav
      ? { ...keyNav }
      : { y: min_y - 1, x: 0, view: false, keyboard: true };
    if (key_value === "enter" && set_key_nav.view === true && activeReader) {
      const book_url = activeReader.is_author ? "creator_reader" : "reader";
      history.push(`/${book_url}/${activeReader.url}/${activeReader.id}`);
      return;
    }
    set_key_nav.keyboard = true;
    if (key_value === "esc") {
      if (set_key_nav.view) {
        set_key_nav.view = false;
        setActiveReader(false);
      } else {
        set_key_nav.keyboard = false;
        setKeyNav(false);
        return;
      }
    }

    switch (key_value) {
      case "esc":
        break;
      case "enter":
        set_key_nav.view = true;
        break;
      case "down":
        set_key_nav.y++;
        break;
      case "up":
        set_key_nav.y--;
        break;
      case "right":
        set_key_nav.x++;
        break;
      case "left":
        set_key_nav.x--;
        break;

      default:
        return;
    }
    if (set_key_nav.view && keyNav && set_key_nav.y !== keyNav.y) {
      return;
    }
    //validate negative vertical value
    let total_cats = categories.length - 1;
    if (
      library_fetch &&
      library_fetch.getRecentReading &&
      library_fetch.getRecentReading.length
    ) {
      total_cats += 1;
    }
    if (!user.is_teacher) {
      total_cats += 1;
    }
    if (set_key_nav.y < min_y) {
      set_key_nav.y = min_y;
    } else if (set_key_nav.y > total_cats) {
      set_key_nav.y = total_cats;
    }
    if (keyNav) {
      const set_x_arr = [...x_arr];
      set_x_arr[keyNav.y] = set_key_nav.x;
      setXarr(set_x_arr);
      if (keyNav && set_key_nav.y !== keyNav.y) {
        set_key_nav.x = x_arr[set_key_nav.y] || 0;
      }
    }
    //validate negative horizontal value
    if (set_key_nav.x < 0) {
      set_key_nav.x = 0;
    } else if (
      keyNav &&
      keyNav.keyboard &&
      set_key_nav.x >= activeCat.books_num - 1
    ) {
      set_key_nav.x = activeCat.books_num - 1;
    }
    setKeyNav(set_key_nav);
  };

  const scrollRow = () => {
    if (!keyNav) return;
    const rows = window.document.getElementsByClassName(`rowNum_${keyNav.y}`);
    if (!rows.length) return;
    const activeRow = rows[0] as HTMLDivElement;
    const catLength = activeRow.dataset.catlength;

    if (catLength) {
      setActiveCat({ id: activeCat.id, books_num: parseInt(catLength) });
    }

    if (!keyNav.view && keyNav.keyboard) {
      activeRow.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    const books = activeRow.getElementsByClassName("library_carousel_row");
    if (!books.length) return;

    const activeBook = books[0] as HTMLDivElement;
    const images = activeBook.getElementsByClassName("reader_block_item");
    if (!images.length) return;

    const image = images[0] as HTMLImageElement;
    const width = image.offsetWidth + 30;
    const scrollValue = keyNav.x * width;

    activeBook.style.transform = `translateX(-${scrollValue}px)`;
  };

  const handleBack = () => {
    const set_key_nav = keyNav
      ? { ...keyNav }
      : { y: -2, x: 0, view: false, keyboard: false };
    set_key_nav.view = false;
    set_key_nav.keyboard = false;
    setActiveCat({ id: false, books_num: 0 });
    setActiveReader(false);
    setKeyNav(set_key_nav);
  };

  const getCatReaders = (level: CatItem) => {
    let readers_to_filter = readers;
    if (level.id === "23") {
      readers_to_filter = [...readers].sort((a, b) => (a.id > b.id ? -1 : 1));
    }
    return readers_to_filter.filter((reader) => {
      if (level.id === "4" && reader.categories.find((c) => c.id === "23")) {
        return false;
      }
      if (reader.coming_soon && !user.is_teacher) return false;
      if (level.is_level) return reader.level_id === level.id;
      const same_cat = reader.categories.filter(
        (category: CatItem) => category.id === level.id,
      );
      return same_cat.length >= 1;
    });
  };

  let rowNum = -1;
  return (
    <main>
      <Helmet title={`${user.lang_name || ""} Library | Flangoo`} />
      <KeyboardEventHandler
        handleKeys={["enter", "esc", "down", "up", "left", "right"]}
        onKeyEvent={(key, e) => {
          handleKeyboardNav(key);
          e.preventDefault();
        }}
      />
      {/* 
      Use this componet to show a banner for teacher when needed
      */}
      {<TeacherBanner />}
      {activeReader ? (
        <div className="book_details_library">
          {" "}
          {activeReader.is_author ? (
            <BookAuthorInfo
              row_title={
                categories.find((c) => c.id === activeCat.id)?.name || ""
              }
              reader={activeReader}
              showCover={false}
              goBack={handleBack}
              user={user}
            />
          ) : (
            <BookInfo
              reader={activeReader}
              goBack={handleBack}
              user={user}
              row_title={
                categories.find((c) => c.id === activeCat.id)?.name || ""
              }
            />
          )}
        </div>
      ) : null}
      {user.show_steps ? (
        <StarterSteps
          discardFunction={discardFunction}
          active_lang={user.lang_name || ""}
        />
      ) : null}
      {get_assignment && get_assignment.assignments.length > 0 ? (
        <Assigment assignments={get_assignment.assignments} />
      ) : null}
      <div
        className={`${
          get_assignment && get_assignment.assignments.length > 0 ? "mt-0" : ""
        } first-container last-container container-fluid text-center books_page ${
          activeReader ? "active_reader" : ""
        }`}
      >
        {!activeCat.id ? <LanguageSelect /> : null}
        {library_fetch &&
        library_fetch.getContinueReading &&
        library_fetch.getContinueReading.length > 0 ? (
          <ReadersRow
            disableActiveRow={handleBack}
            arrowNav={arrowNav}
            is_trending={false}
            is_continue_reading={true}
            is_first={true}
            rowNum={rowNum}
            keyNav={keyNav}
            totalRows={categories.length}
            slectActiveReader={slectActiveReader}
            activeReader={activeReader ? activeReader.id : false}
            isActive={activeCat.id === "continue_reading"}
            title="Continue Reading"
            hiddenRow={
              keyNav &&
              activeCat.id !== false &&
              activeCat.id !== "continue_reading" &&
              (keyNav.keyboard || keyNav.view)
                ? true
                : false
            }
            cat_id="continue_reading"
            readers={library_fetch.getContinueReading}
          />
        ) : null}
        {readers && categories
          ? categories.map((level: CatItem, index: number) => {
              const level_readers = getCatReaders(level);
              rowNum++;
              if (level_readers.length < 1) return null;
              return (
                <ReadersRow
                  disableActiveRow={handleBack}
                  arrowNav={arrowNav}
                  key={`readers_row${level.id}`}
                  rowNum={rowNum}
                  totalRows={categories.length}
                  keyNav={keyNav}
                  slectActiveReader={slectActiveReader}
                  isActive={activeCat.id === level.id}
                  hiddenRow={
                    keyNav &&
                    activeCat.id !== false &&
                    activeCat.id !== level.id &&
                    (keyNav.keyboard || keyNav.view)
                      ? true
                      : false
                  }
                  is_trending={level.is_trending}
                  is_first={
                    library_fetch &&
                    library_fetch.getContinueReading &&
                    library_fetch.getContinueReading.length > 0
                      ? false
                      : index <= 0
                  }
                  title={level.name}
                  activeReader={activeReader ? activeReader.id : false}
                  cat_id={level.id}
                  readers={level_readers}
                />
              );
            })
          : null}
        {readers.length === 0 ? <NoBooks /> : null}
        {library_fetch &&
        library_fetch.getRecentReading &&
        library_fetch.getRecentReading.length > 0 ? (
          <ReadersRow
            disableActiveRow={handleBack}
            arrowNav={arrowNav}
            is_trending={false}
            is_continue_reading={false}
            is_first={false}
            isActive={activeCat.id === "recent_reading"}
            rowNum={rowNum + 1}
            totalRows={categories.length}
            keyNav={keyNav}
            slectActiveReader={slectActiveReader}
            activeReader={activeReader ? activeReader.id : false}
            title="Recently Read"
            hiddenRow={
              keyNav &&
              activeCat.id !== false &&
              activeCat.id !== "recent_reading" &&
              (keyNav.keyboard || keyNav.view)
                ? true
                : false
            }
            cat_id="recent_reading"
            readers={library_fetch.getRecentReading}
          />
        ) : null}
        {!user.is_teacher ? (
          <RenderComingSoon
            readers={readers}
            rowNum={
              library_fetch &&
              library_fetch.getRecentReading &&
              library_fetch.getRecentReading.length > 0
                ? rowNum + 2
                : rowNum + 1
            }
            arrowNav={arrowNav}
          />
        ) : null}
        {!user.is_teacher && user.first_visit ? (
          <FirstModal user={user} />
        ) : null}
        {library_fetch?.getpopups || dataContext?.first_data?.popups ? (
          <MarketingModal
            popups={
              library_fetch?.getpopups || dataContext.first_data?.popups || []
            }
          />
        ) : null}
      </div>
    </main>
  );
};

const TeacherBanner = () => {
  const user = getAuthCookie(true);
  if (!user.is_teacher || user.lang_id !== "1") {
    return null;
  }
  return (
    <a
      href="https://teachersdiscovery.com/products/sugar-skull-kit?_pos=1&_psq=sugar+sk&_ss=e&_v=1.0"
      target="_blank"
      rel="noreferrer"
      className="top_banner"
    >
      <img
        src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/Sugar_Skull_Flangoo_banner_2026.jpg"
        alt="Fall Sugar Skull Kit"
      />
    </a>
  );
};

const NoBooks = () => {
  const user = getAuthCookie(true);
  let help_text =
    "Your district or account coordinator hasn't added any books to your account yet. Please reach out to them to add books to your library.";
  if (!user.is_teacher) {
    help_text =
      "Your teacher hasn't added any books to your account yet. Please reach out to them to add books to your library.";
  }

  return (
    <div className="no_books w-50 mx-auto mt-5">
      <IconJumbotron
        txt="No books available"
        help_text={help_text}
        icon="far fa-book-open"
      />
    </div>
  );
};
export default Library;
